<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">조제처리관리</h2>
          <article>
            <ul class="search_filter">
              <li class="w50">
                <p>한의원명</p>
                <input type="text" v-model="searchInfo.clinic_nm" placeholder="한의원명을 입력하세요" class="form_control" @keyup.enter="fn_search"> 
              </li>
              <li>
                <p style="width:250px">환자명</p>
                <input type="text" v-model="searchInfo.patient_nm" placeholder="환자명을 입력하세요" class="form_control" @keyup.enter="fn_search">
              </li>
              <li>
                <p style="width:250px">처방명/약속상품명</p>
                <input type="text" placeholder="처방명/약속상품명을 입력하세요" class="form_control" @keyup.enter="fn_search">
              </li>
              <li>
                <p>처리상태</p>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio"  value="" v-model="searchInfo.pharmacy_status">
                  <label for="radio1">전체</label>
                </div>  
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio"  value="P1" v-model="searchInfo.pharmacy_status">
                  <label for="radio2">조제접수</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio3" name="radio" value="P2" v-model="searchInfo.pharmacy_status" >
                  <label for="radio3">조제중</label>
                </div>                                          
              </li>
              <li>
                <p>신청일자</p>
                <Datepicker v-model="searchInfo.startDate" :defaultDate="searchInfo.startDate"/> 
                <span>~</span>
                <Datepicker v-model="searchInfo.endDate" :defaultDate="searchInfo.endDate"/> 
              </li> 
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="list no_view">
              <colgroup>
                <col width="10%">
                <col width="5%">
                <col width="15%">
                <col width="15%">
                <col width="10%">
                <col width="5%">
                <col width="5%">
                <col width="5%">
                <col width="5%">
                <col width="5%">
              </colgroup>
              <thead>
                <tr>
                  <th>신청일자</th>
                  <th>주문번호</th>
                  <th>처방명</th>
                  <th>한의원명</th>
                  <th>환자명</th>
                  <th>용량</th>
                  <th>첩수</th>
                  <th>팩수</th>
                  <th>처리</th>
                  <th>처방전</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="pharmacyList.length == 0">
                    <td colspan="7"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in pharmacyList" :key="index">
                  <td><span>{{ item.payment_complete_dt }}</span></td>
                  <td><span>{{ item.prescribe_seq }}</span></td>
                  <td class="al"><span>{{ item.prescribe_nm }}</span></td>
                  <td><span>{{ item.clinic_nm }}</span></td>
                  <td><span>{{ item.patient_nm }}</span></td>
                  <td><span>{{ item.pack_capacity }}</span></td>
                  <td><span>{{ item.prescribe_pack_cnt }}</span></td>
                  <td><span>{{ item.packs_cnt }}</span></td>
                  <td>
                    <div class="form_inline">
                    <button v-if="item.work_status === 'P1'" :class="'bdge bd_blue'" @click="fn_change_ststus(item)">조제접수</button>
                    <button v-else-if="item.work_status === 'P2'" :class="'bdge bd_green'" @click="fn_change_ststus(item)">조제중</button>
                    <button v-if="item.work_status != 'P1'" class="bdge" @click="fn_prev_ststus(item)">취소</button>
                    <!-- <button v-else></button> -->
                    </div>
                  </td>
                  <td>
                    <div class="form_inline">
                      <button :class="item.Prescribe_print_yn == 'N' ? 'bdge bd_white' : 'bdge bd_gray'" @click="fn_print_modal_open(item.prescribe_seq, item.prescribe_type)">처방전</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_move_pharmacy" v-show="pagingShow"/>
          </div>
        </section>
      </div>
      <workingModal 
        :title="'조제신청서'"
        :prescribe_seq="selectPrescribeSeq" 
      />
      <promisePrescriptModal
          :title="'조제신청서'"
          :prescribe_seq="selectPrescribeSeq"
      />
    </div>
</template>

<script>
  import axios from 'axios'  
  import Pagination from "@/components/AdminPagination.vue"
  import Datepicker from '@/components/Datepicker.vue'
  import workingModal from "@/modal/admin/workingModal.vue"
  import PromisePrescriptModal from "@/modal/admin/promisePrescriptModal.vue";

  export default {
    name: 'pharmacyMngt',
    components: {
      PromisePrescriptModal,
      Pagination,
      Datepicker,
      workingModal
    },
    data() {
      return {
        searchInfo : {
          prescribe_nm : '',
          clinic_nm : '',
          patient_nm : '',
          pharmacy_status : '',
          startDate : '',
          endDate : '',
          pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
          }                
        },
        pagingShow : false,
        pharmacyList: [],
        selected: null,
        selectPrescribeSeq : 0
      }
    },
    created(){
      this.fn_search();
    },
    methods : {
      fn_search(){
        console.log("@@@ search");
        axios
            .post("/api/admin/work/getPharmacyList", this.searchInfo)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                this.pharmacyList = res.data.pharmacyList;

                console.log("@@@@ pharmacyList : %o",this.pharmacyList);

                this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                if(this.searchInfo.pageInfo.totPage> 0){
                    this.pagingShow = true;                          
                }                        

            })
            .catch((err) => console.log(err));
        },
      fn_move_pharmacy(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
      //print 모달 호출
      fn_print_modal_open(prescribe_seq, prescribe_type){
        this.selectPrescribeSeq = prescribe_seq;

        this.$nextTick(() => {
          if(prescribe_type != 'P'){
            this.$bvModal.show("workingModal");
          }else{
            this.$bvModal.show("promisePrescriptModal");
          }
        });

      },
      fn_change_ststus(item){
        
        let changeStatus = "";

        if(item.prescribe_type == 'P'){
          if(item.work_status == 'P1'){
            changeStatus = "P5";        //조제중
          }
        }else{
          if(item.work_status == 'P1'){
            changeStatus = "P2";        //조제중
          }else if(item.work_status == 'P2'){
            changeStatus = "P3";        //탕전중
          }
        }

        let param = {prescribe_seq : item.prescribe_seq, work_status : changeStatus}

        axios
            .post("/api/admin/work/updatePrescribeStatus", param)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                
                this.fn_search();

            })
            .catch((err) => console.log(err));
      },
      fn_prev_ststus(item){

        let changeStatus = "";

        let last_process = item.work_status.substr(item.work_status.length-1, 1);
        let prev_process_num = Number(last_process) - 1;
        let prev_process = 'P'+prev_process_num;

        let param = {prescribe_seq : item.prescribe_seq, work_status : prev_process}

        axios
          .post("/api/admin/work/updatePrescribeStatus", param)
          .then((res) => {
              console.log("@@@@ res : %o",res);
              
              this.fn_search();

          })
          .catch((err) => console.log(err));
    }
    }
  }
</script>
